export const GET_EXPENSES_TYPES = 'GET_EXPENSES_TYPES';
export const CREATE_EXPENSES_TYPE = 'CREATE_EXPENSES_TYPE';
export const REMOVE_EXPENSES_TYPE = 'REMOVE_EXPENSES_TYPE';
export const UPDATE_EXPENSES_TYPE = 'UPDATE_EXPENSES_TYPE';
